module.exports = __webpack_public_path__ + "img/icon-calendar-alt.f6b410d8.svg";